import React from 'react';
import { ButtonApp } from 'src/components/Button';
import { useStyles } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceButton/styles';
import { OverridableStringUnion } from '@mui/types';
import { ButtonPropsColorOverrides } from '@mui/material/Button/Button';

interface IMarketplaceButtonProps {
  label: string,
  startIcon: React.ReactNode,
  onClick: () => void,
  color?: OverridableStringUnion<
    'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    ButtonPropsColorOverrides
  >
  type?: 'submit' | 'reset' | 'button' | undefined;
}
export const MarketplaceButton: React.FC<IMarketplaceButtonProps> = React.forwardRef(
  ({ label, startIcon, ...props }) => {
    const styles = useStyles();
    return (
      <ButtonApp
        variant="outlined"
        startIcon={startIcon}
        className={styles.btn}
        {...props}
      >
        {label}
      </ButtonApp>
    );
  },
);
